import { Link } from "react-router-dom";
import { ArrowRight, Phone } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const CTASection = ({ title, text, image, dark = true }) => (
  <section data-testid="cta-section" className="relative overflow-hidden">
    {image && (
      <div className="absolute inset-0">
        <img src={image} alt="" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-navy/75" />
      </div>
    )}
    {!image && dark && <div className="absolute inset-0 bg-navy" />}
    <div className="relative max-w-[1400px] mx-auto px-6 md:px-12 py-28 md:py-36 text-center">
      <Reveal>
        <span className="text-[11px] tracking-[0.32em] uppercase text-gold">Begin the Conversation</span>
        <h2 className="font-serif font-medium tracking-tight text-4xl md:text-6xl text-ivory mt-6 leading-[1.05] max-w-3xl mx-auto">
          {title}
        </h2>
        <p className="text-ivory/70 text-base md:text-lg font-light mt-6 max-w-xl mx-auto leading-relaxed">
          {text}
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mt-10">
          <Link
            to="/quote"
            data-testid="cta-request-quote-button"
            className="group inline-flex items-center gap-2 bg-gold text-navy text-[13px] tracking-[0.1em] uppercase px-8 py-4 transition-colors duration-300 hover:bg-ivory"
          >
            Request a Quote
            <ArrowRight size={15} className="transition-transform duration-300 group-hover:translate-x-1" />
          </Link>
          <Link
            to="/contact"
            data-testid="cta-talk-to-team-button"
            className="group inline-flex items-center gap-2 border border-ivory/40 text-ivory text-[13px] tracking-[0.1em] uppercase px-8 py-4 transition-colors duration-300 hover:border-gold hover:text-gold"
          >
            <Phone size={15} />
            Talk to Our Team
          </Link>
        </div>
      </Reveal>
    </div>
  </section>
);

export default CTASection;
